import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoModal, DiscoModalProps } from "@disco-ui"
import { TestIDProps } from "@utils/typeUtils"
import GenerateWithAIForm, { GenerateWithAIFormStore } from "./GenerateWithAIForm"

interface Props extends TestIDProps {
  onSubmit: () => void
  onClose: () => void
  title: string
  placeholder: string
  isOpen: boolean
  modalContentLabel: string
  form: GenerateWithAIFormStore
  canUploadMedia?: boolean
  classes?: Pick<DiscoModalProps, "classes">["classes"]
}

export default function GenerateWithAIModal({
  testid = "GenerateWithAIModal",
  onSubmit,
  onClose,
  title,
  modalContentLabel,
  placeholder,
  form,
  isOpen,
  classes: customClasses,
  canUploadMedia,
}: Props) {
  const classes = useStyles()

  return (
    <DiscoModal
      testid={testid}
      modalContentLabel={modalContentLabel}
      isOpen={isOpen}
      classes={{
        body: classes.body,
        headerRow: classes.header,
        ...customClasses,
      }}
      onClose={onClose}
      title={title}
      body={
        <GenerateWithAIForm
          form={form}
          onSubmit={onSubmit}
          testid={testid}
          placeholder={placeholder}
          canUploadMedia={canUploadMedia}
        />
      }
      width={"720px"}
      maxWidth={"90vw"}
    />
  )
}

const useStyles = makeUseStyles((theme) => ({
  body: {
    padding: theme.spacing(0.5, 3, 3),
  },
  header: {
    padding: theme.spacing(3, 3, 2.5),
  },
}))
